import React from 'react';
// utils
import PropTypes from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './ResourcesPlaceholder.mod.css';

const cn = classnames.bind(styles);

const ResourcesPlaceholder = ({ type }) => {
  const title = type
    ? 'No resources from the modules yet. They will be added while you pass through the modules'
    : 'No favorites yet';

  return <div className={cn('placeholder')}>{title}</div>;
};

ResourcesPlaceholder.propTypes = {
  type: PropTypes.string
};

export default ResourcesPlaceholder;



// WEBPACK FOOTER //
// ./src/containers/Resources/components/RecourcesPlaceholder.jsx